import { Component, OnInit, HostListener } from '@angular/core';
import { label } from 'src/app/constants/labels';
import { BaseAPIService } from 'src/app/shared/services/api.base.service';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { environment } from 'src/environments/env-proxy';
import { JwtHelperService } from '@auth0/angular-jwt';

import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-sp-header',
  templateUrl: './sp-header.component.html',
  styleUrls: ['./sp-header.component.scss']
})
export class SpHeaderComponent implements OnInit {
  labels;
  userName = '';
  showDropdown = false;
  showSidePanel = false;

  public user;
  public language: string;
  public isLoggedIn = false;
  public isInternalUser = 'true'; // default isInternalUser is true
  public loggedInUser: string | null;
  public urls = {};

  serverUrl = environment.serverUrl;
  _context = null;
  currentYear: number;
  privacyPolicyFileName:string;
  privacyPolicyFilePath:string;
  termsAndConditionsFileName:string;
  termsAndConditionsFilePath:string;

  constructor(private readonly baseService: BaseAPIService, private readonly toastr: ToastrService, public jwtHelper: JwtHelperService,
              private readonly authenticationService: AuthenticationService, private readonly http: HttpClient) {}
  // click to close menu
  @HostListener('document:click', ['$event.target']) public onClick() {
    this.dropdownToggle();
  }
  /**
   * Toggles user dropdown
   * returns logout option in dropdown
   */ 
  dropdownToggle(){
    if (this.showDropdown) {
      this.showDropdown = false;
    }
  }
  // esc key to close the menu
  @HostListener('document:keydown.escape', ['$event']) public onKeydownHandler(_event: KeyboardEvent) {
    this.dropdownToggle();
  }

  /**
   * initialization  of Header component
   * returns header component.
   */
  ngOnInit() {
    this.labels = label;
    this.currentYear = new Date().getFullYear();
    this.isLoggedIn = this.authenticationService.isAuthenticated();
    /* istanbul ignore next */
    this.loggedInUser = this.isLoggedIn ? this.authenticationService.authenticatedUser : '';
    // tslint:disable-next-line: max-line-length
    const context = JSON.parse(sessionStorage.getItem('context'));
    if(context) {
      this.isInternalUser = context.idms.isInternal.toLowerCase();  
    }
    /* istanbul ignore next */
    this.urls = JSON.parse(this.authenticationService.urls);
    this.language = localStorage.getItem('language');

    this.privacyPolicyFileName = 'Privacy Policy.pdf';
    this.privacyPolicyFilePath = 'assets/Industry_Services_Portal_Privacy_Policy.pdf';
    
    this.termsAndConditionsFileName = 'Terms And Conditions.pdf';
    this.termsAndConditionsFilePath = 'assets/Industry_Services_Portal_Terms.pdf';
  }

  /*
    * Function to toggle dropdown menu in header
    * 
  */
  userDropDown(event) {
    this.showDropdown = !this.showDropdown;
    event.stopPropagation();
  }

  /*
    * Logout of the application
    * 
  */
  logout() {
    const token = sessionStorage.getItem('token');
    const text: string | null =
      sessionStorage.getItem('context') || localStorage.getItem('context');
      this._context = text && JSON.parse(text);
      /* istanbul ignore next */
    if (token !== null && this._context) {
      this.baseService.DELETESESSION(environment.serverAuth + '/api/application/TerminateActiveSession',token).subscribe((_data) => {
        this.authenticationService.logout();
      },
    /* istanbul ignore next */
      (_error) => {
        this.toastr.error(this.labels.errorMessage2, '', {
          timeOut: environment.toasterTimeOut
        });
      });
    }
  }

  openSideMenu($event) {
    $event.stopPropagation();
    this.showSidePanel = !this.showSidePanel;
  }

}